import { FC, useState } from 'react';
import Search from '../../component/search/search';
import { Mode } from '../../component/datePickerV2/datePicker.type';
import DatePickerV2 from '../../component/datePickerV2/datePicker';
import { renderSettingsMenuWithDropdown } from '../userManagement/userManagementHelper';
import Setting from '../../assets/setting.png';
import { DeletedHarmReportsTableHeaderProps } from './deletedHarmReports.type';

export const DeletedHarmReportsTableHeader: FC<
  DeletedHarmReportsTableHeaderProps
> = (props) => {
  const [isOpenSettingMenu, setIsOpenSettingMenu] = useState<boolean>(false);

  return (
    <div className="flex items-center justify-between pl-10 pr-8">
      <div className="flex">
        <DatePickerV2
          mode={Mode.Single}
          handleApply={(range) => {
            if (range?.from && props.handleSelectedDate) {
              props.handleSelectedDate(range.from);
            }
          }}
          finalRange={{
            from: props.selectedDate,
            to: undefined,
          }}
          className="top-[165px]"
        />
      </div>

      <div className="flex">
        <Search
          query={props.searchQuery}
          onChange={props.handleOnChangeSearch}
          placeholder="Search"
          iconSize={13}
          iconRight={false}
          id="deleted-harm-reports-search"
          containerClass="w-22 ml-3 mr-3"
          inputClass="text-sm"
        />
        {props.children}
        {renderSettingsMenuWithDropdown(
          Setting,
          isOpenSettingMenu,
          () => setIsOpenSettingMenu((prev) => !prev),
          [],
          () => {},
          true,
        )}
      </div>
    </div>
  );
};
